import { Link } from "react-router-dom";

/**
 * Wordmark + stylised 360° sphere icon.
 * Use as inline link in topbars.
 */
export default function Logo({ to = "/", size = "md", className = "" }) {
  const px = size === "lg" ? 32 : size === "sm" ? 22 : 26;
  const text =
    size === "lg" ? "text-2xl" : size === "sm" ? "text-base" : "text-lg";
  return (
    <Link
      to={to}
      className={`inline-flex items-center gap-2.5 group ${className}`}
      data-testid="brand-logo"
    >
      <span
        className="inline-flex items-center justify-center rounded-xl bg-[#17171a] border border-[#2a2a30] transition-colors group-hover:border-[#ff6b35]/40"
        style={{ width: px + 12, height: px + 12 }}
      >
        <SphereMark size={px} />
      </span>
      <span className={`font-semibold tracking-tight text-white ${text}`}>
        360<span className="text-[#ff6b35]">-</span>Kirchner
      </span>
    </Link>
  );
}

export function SphereMark({ size = 24 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      aria-hidden="true"
    >
      <defs>
        <linearGradient id="logo-grad" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#ff6b35" />
          <stop offset="100%" stopColor="#ff3d6e" />
        </linearGradient>
      </defs>
      <ellipse cx="32" cy="32" rx="22" ry="22" fill="none" stroke="url(#logo-grad)" strokeWidth="3" />
      <ellipse cx="32" cy="32" rx="22" ry="8" fill="none" stroke="url(#logo-grad)" strokeWidth="2.2" opacity="0.7" />
      <ellipse cx="32" cy="32" rx="8" ry="22" fill="none" stroke="url(#logo-grad)" strokeWidth="2.2" opacity="0.7" />
    </svg>
  );
}
